import React from 'react';
import classnames from 'classnames';
import styles from './RadioButton.module.css';
import parseString from "../parseString";


class RadioButton extends React.Component {

  createMarkup = text => {
    return {__html: text.replace(/\n/g, '<br>')}
  };

  render() {
    const {componentBlock, contentData, id, changeData, title} = this.props;

    let parsedTitle = title;

    if (title.includes("</span>")) {
      parsedTitle = parseString(title);
    }

    console.log(parsedTitle)

    return (
      <div
        className={classnames({
          [styles.wrap]: true,
          [styles.visibleWrap]: componentBlock.visibility,
          [styles.invisibleWrap]: !componentBlock.visibility
        })}
      >

        <div className={styles.title} dangerouslySetInnerHTML={this.createMarkup(parsedTitle)}/>

        <div>
          <div
            className={classnames({
              [styles.yesNoWrap]: contentData[0].item === 'Да' || contentData[0].item === 'Нет',
            })}
          >
            {contentData.map(item => (
              <div
                id={item.key}
                key={item.key}
                className={classnames({
                  [styles.radioButtonWrap]: true,
                  [styles.yesNoRadioButtonWrap]: contentData[0].item === 'Да' || contentData[0].item === 'Нет',
                  [styles.radioButtonWrapUnChecked]: !item.checked,
                  [styles.radioButtonWrapChecked]: item.checked,
                })}
                onClick={(e) => {
                  if (e.target.id == item.key) {
                    changeData(id, !item.checked, item.key, item, componentBlock);
                  }
                }}
              >
                <input
                  type="radio"
                  id={item.key}
                  className={styles.radioButton}
                />
                <label
                  id={item.key}
                  htmlFor={item.item}
                  className={styles.radioButtonText}
                >
                  {item.item}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default RadioButton;
